import {gh} from '../../general/general-helpers';

let loaderSelector = YadroCommentFormData && YadroCommentFormData?.loader || '';
let ajaxUrl = YadroCommentFormData && YadroCommentFormData?.ajaxUrl || '';
let ajaxAction = YadroCommentFormData && YadroCommentFormData?.action || '';
let smartCaptchaKey = YadroCommentFormData && YadroCommentFormData?.smartCaptchaKey || '';

let commentForm;
let policyCheck;
let submitButton;

function createForm(htmlString) {
	var div = document.createElement('div');
	div.innerHTML = htmlString.trim();

	// Change this to div.childNodes to support multiple top-level nodes.
	return div.firstChild;
}

/**
 * Makes a string of parameters to send in request to a server.
 * @param {Object} params
 * @returns {string}
 */
function encodeParams( params ) {

	return Object.entries( params ).map( param => param.map( encodeURIComponent ).join( "=" )).join( "&" );
}


/**
 * Disable or enable submit button for Comment Form
 * by accepting Privacy Policy
 * @param $policyCheckboxLabel
 */
function checkForPolicyAccepted() {
	if (!policyCheck) {
		return;
	}

	if (!policyCheck.checked) {
		submitButton.setAttribute('disabled', '');
		submitButton.setAttribute('title', '');
	} else {
		submitButton.removeAttribute('disabled');
		submitButton.setAttribute('title', 'Вы должны согласиться с политикой конфиденциальности');
	}
}

function loadSmartCaptcha() {
	if (!window.smartCaptcha) {
		console.error("SmartCaptcha script not loaded");
		return;
	}

	const container = commentForm.querySelector('#smartcaptcha');
	if (!container) {
		console.error("Container 'smartcaptcha' not found in the form");
		return;
	}

	window.smartCaptcha.render('smartcaptcha', {
		sitekey: smartCaptchaKey,
		invisible: true,
		callback: function (token) {
			const formElement = commentForm.querySelector('form');
			if (formElement) {
				HTMLFormElement.prototype.submit.call(formElement);
			}
		},
	});
}

function addEvents() {

	// if the form is already initiated/loaded return
	if (commentForm.yeFormInitiated) return;

	const formElement = commentForm.querySelector('form');
	if (formElement) {
		formElement.addEventListener('submit', (event) => {
			event.preventDefault();
			if (window.smartCaptcha) {
				window.smartCaptcha.execute();
			} else {
				formElement.submit();
			}
		});
	}

	policyCheck = commentForm.querySelector('#policy');
	submitButton = commentForm.querySelector('#submit');
	commentForm.querySelectorAll(' form a').forEach((elem, i) => {

		if ( ! gh.isMobileDevice ) {
			elem.classList.add('before-std', 'accent-underline', '--anim', 'd-inline-block', 'color-gray-text');
		}
	});

	commentForm.querySelector('form').removeAttribute('novalidate');

	if (policyCheck) {
		policyCheck.addEventListener('change', () => {
			checkForPolicyAccepted();
		});
	}

	// mark the form as already initiated/loaded
	commentForm.yeFormInitiated = true;

}

function ajaxLoadForm( loader ) {
	if (loader) {
		let cfAjaxFormData = {
			action: ajaxAction,
			id: loader.dataset?.id,
		};

		let encodedData = encodeParams(cfAjaxFormData);

		fetch(ajaxUrl, {
			method: 'POST', headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
			}, body: encodedData
		})
			.then(res => res.text())
			.then(response => {
				commentForm = createForm(response);
				loader.after(commentForm);
				addEvents();
				checkForPolicyAccepted();
				loader.remove();
				try {
					loadSmartCaptcha();
				} catch (e) {
					console.error("Captcha init failed", e);
				}
				// TODO Check if exists
				if ( typeof window.addComment == 'object' && window.addComment.init == 'object' ) {
					window.addComment.init;
				}
			})
			.then(() =>{
				document.dispatchEvent( new CustomEvent('yadroСommentsAjaxLoaded' ) );
			})
			.catch(error => {
				console.log(error);
			});
	}
} // FNC


['DOMContentLoaded', 'yadroCommentsAjaxLoad'].forEach( eventName => {
	document.addEventListener( eventName, () => {
		let loader = document.querySelector(loaderSelector);
		ajaxLoadForm( loader );
	} ); // addEventListener
} ); // ON EVENTS :